var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"sellers@7bb3623f0b4e9374741459bd83e47183d3da1de8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sellers@riqra-pp"]={id:"sellers@7bb3623f0b4e9374741459bd83e47183d3da1de8"};
      